import { ReportChartPreview, ReportChecklistPreview } from "../certificatePrint/certificateTypes";

export const PATIENT_REPORT_SAMPLE_TABLES: Record<
  string,
  { columns: string[]; rows: string[][] }
> = {
  complainTable: {
    columns: ["NO", "DESCRIPTION", "TOOTH"],
    rows: [
      ["01", "Pain on chewing", "16"],
      ["02", "Sensitivity to cold", "21"],
    ],
  },
  investigationTable: {
    columns: ["NO", "INVESTIGATION", "TOOTH", "DESCRIPTION"],
    rows: [["01", "X-ray", "16", "Periapical radiolucency"]],
  },
  diagnoseTable: {
    columns: ["NO", "DIAGNOSIS", "TOOTH", "NOTE", "PRIORITY"],
    rows: [["01", "Pulpitis", "16", "Irreversible", "High"]],
  },
  treatmentTable: {
    columns: ["NO", "DATE", "TREATMENT", "TOOTH", "QTY", "PRICE", "STATUS"],
    rows: [["01", "12 Mar 2026", "RCT", "16", "1", "25,000", "Done"]],
  },
  paymentTable: {
    columns: ["NO", "DATE", "INVOICE", "TOTAL", "DISCOUNT", "CASH", "CARD"],
    rows: [["01", "12 Mar 2026", "INV-1001", "25,000", "500", "10,000", "14,500"]],
  },
  prescriptionTable: {
    columns: ["NO", "DRUGS", "DOSE", "FREQUENCY", "DURATION"],
    rows: [
      ["01", "Amoxicillin", "500mg", "TDS", "5"],
      ["02", "Ibuprofen", "400mg", "TDS", "3"],
    ],
  },
};

const yes = (label: string, note?: string) => ({
  label,
  checked: true,
  note,
});
const no = (label: string) => ({ label, checked: false });

export const PATIENT_REPORT_SAMPLE_CHECKLISTS: Record<
  string,
  ReportChecklistPreview
> = {
  medicalHistoryChecklist: {
    items: [
      yes("Allergies", "Penicillin"),
      no("Diabetes mellitus – Drugs"),
      no("Hypertension – Drugs"),
      no("Dyslipidemia"),
      no("Gastric problem"),
      yes("High BP", "On medication"),
      no("Diabetes"),
      no("Monthly injection"),
      no("Pregnancy / breast feeding"),
      no("Cough / cold / fever"),
      no("Chest pain / heart"),
      no("Epilepsy"),
      no("Previous extraction"),
      no("Previous surgeries"),
      no("COVID-19 (3 doses)"),
      no("Drug history"),
      no("Dietary history"),
      no("Brushing history"),
      no("Medical history (note)"),
      no("Oral hygiene history"),
      no("Habit history"),
      no("Family history"),
      no("Social history"),
      no("Extra-oral examination"),
      no("Intra-oral examination"),
    ],
  },
};

export const PATIENT_REPORT_SAMPLE_CHARTS: Record<string, ReportChartPreview> = {
  diagnosisChart: {
    marked: ["16"],
    actions: [
      {
        toothNo: "16",
        isTop: true,
        hasSurface: false,
        color: "#ef4444",
      },
    ],
  },
};

export const PATIENT_REPORT_SAMPLE_DATA: Record<string, string> = {
  clinicName: "VISO DENTAL CLINIC",
  clinicAddress: "12 Flower Road, Colombo 07",
  clinicPhone: "011 234 5678",
  generatedAt: "21 Sep 2026, 14:00",
  patientName: "Ms. Sample Patient",
  patientGender: "Female",
  patientAge: "31 yrs",
  patientDob: "25 Aug 1994",
  patientReg: "J/A1/2024",
  patientMobile: "077 123 4567",
  patientAddress: "12 Flower Road, Colombo",
  diagnosisChart: "Adult chart with marked surfaces (shown on generated PDF).",
  medicalHistory: "Allergies: Penicillin\nHigh BP: On medication\nDiabetes: No",
};

export function mergePatientReportPreviewData(
  sample: Record<string, string>,
  clinic?: {
    clinicName?: string;
    address?: string;
    tpNo?: string;
    phoneTwo?: string;
  }
): Record<string, string> {
  const pick = (value?: string, fallback?: string) => {
    const v = String(value ?? "").trim();
    if (!v || v === "clinicName" || v === "12454" || v === "0771234567") {
      return fallback ?? "";
    }
    return v;
  };
  const phones = [clinic?.tpNo, clinic?.phoneTwo].filter(Boolean).join("  |  ");
  return {
    ...sample,
    clinicName: pick(clinic?.clinicName, sample.clinicName).toUpperCase(),
    clinicAddress: pick(clinic?.address, sample.clinicAddress),
    clinicPhone: pick(phones || clinic?.tpNo, sample.clinicPhone),
  };
}
